import React from 'react';

import { useTranslation } from 'react-i18next';
import { useContainer } from 'unstated-next';

import { getUrls } from '../../utils/url';
import { ActionButton } from './index.styles';
import TemplatesContainer from './TemplateContext';
import { openWindow } from './utils';

const FilesSection: React.FC = () => {
    const { t } = useTranslation('templates');
    const { web } = getUrls();
    const { createEditResponse } = useContainer(TemplatesContainer);

    const openSharedFiles = () => {
        const token = createEditResponse?.token;
        const link = `${web}/files/files.html?token=${token}&content_type=file`;
        openWindow({ link, width: 800, height: 650 });
    };

    return (
        <>
            <ActionButton disabled={!createEditResponse} onClick={openSharedFiles} variant="contained">
                {t('shared-files')}
            </ActionButton>
        </>
    );
};

export default FilesSection;
